import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import {
  House,
  Kanban,
  UsersThree,
  Buildings,
  ChartBar,
  TrendUp,
  Robot,
  SignOut,
  User,
  UserPlus,
  UserCircle,
  MapTrifold
} from '@phosphor-icons/react';

const Sidebar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { user, logout } = useAuth();

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  const menuItems = [
    { path: '/dashboard', label: 'Dashboard', icon: House, roles: ['admin', 'corretor', 'diretoria'] },
    { path: '/novo-lead', label: 'Novo Lead', icon: UserPlus, roles: ['admin', 'corretor', 'diretoria'] },
    { path: '/kanban', label: 'CRM Kanban', icon: Kanban, roles: ['admin', 'corretor', 'diretoria'] },
    { path: '/ia', label: 'IA de Qualificação', icon: Robot, roles: ['admin', 'corretor', 'diretoria'] },
    { path: '/empreendimentos', label: 'Empreendimentos', icon: Buildings, roles: ['admin', 'diretoria'] },
    { path: '/mercados-regioes', label: 'Portfólio Comercial', icon: MapTrifold, roles: ['admin', 'diretoria'] },
    { path: '/corretores', label: 'Meus Leads', icon: UsersThree, roles: ['corretor'] },
    { path: '/meu-perfil', label: 'Meu Perfil', icon: UserCircle, roles: ['corretor'] },
    { path: '/gestao-corretores', label: 'Corretores', icon: UsersThree, roles: ['admin', 'diretoria'] },
    { path: '/diretoria', label: 'Diretoria', icon: ChartBar,
  TrendUp, roles: ['admin', 'diretoria'] },
    { path: '/conflitos', label: 'Conflitos', icon: ChartBar,
  TrendUp, roles: ['admin', 'diretoria'] },
  ];

  const filteredItems = menuItems.filter((item) => item.roles.includes(user?.role));

  return (
    <div className="fixed left-0 top-0 h-screen w-64 bg-slate-900 text-slate-100 flex flex-col z-50 overflow-hidden">
      {/* Logo */}
      <div className="p-6 border-b border-slate-800">
        <h1 className="text-xl font-bold text-white" data-testid="sidebar-logo">
          Orquestrador de Leads
        </h1>
        <p className="text-xs text-slate-400 mt-1">Inteligência Imobiliária</p>
      </div>

      {/* Menu */}
      <nav className="flex-1 min-h-0 overflow-y-auto p-4 space-y-1">
        {filteredItems.map((item) => {
          const Icon = item.icon;
          const isActive = location.pathname === item.path;
          return (
            <Link
              key={item.path}
              to={item.path}
              data-testid={`sidebar-link-${item.path.substring(1)}`}
              className={`flex items-center gap-3 px-4 py-3 rounded-lg transition-all duration-200 ${
                isActive
                  ? 'bg-slate-800 text-white font-medium'
                  : 'text-slate-300 hover:bg-slate-800/50 hover:text-white'
              }`}
            >
              <Icon size={20} weight={isActive ? 'fill' : 'regular'} />
              <span className="text-sm">{item.label}</span>
            </Link>
          );
        })}
      </nav>

      {/* User Info & Logout */}
      <div className="shrink-0 p-4 border-t border-slate-800 bg-slate-900">
        <div className="flex items-center gap-3 px-4 py-3 rounded-lg bg-slate-800/50 mb-2">
          <div className="w-8 h-8 rounded-full bg-emerald-500 flex items-center justify-center">
            <User size={16} weight="bold" className="text-white" />
          </div>
          <div className="flex-1 min-w-0">
            <p className="text-sm font-medium text-white truncate">{user?.name}</p>
            <p className="text-xs text-slate-400 truncate">{user?.email}</p>
          </div>
        </div>
        <button
          onClick={handleLogout}
          data-testid="logout-button"
          className="w-full flex items-center gap-3 px-4 py-3 rounded-lg text-slate-300 hover:bg-red-500/10 hover:text-red-400 transition-all duration-200"
        >
          <SignOut size={20} />
          <span className="text-sm">Sair</span>
        </button>
      </div>
    </div>
  );
};

export default Sidebar;